import React, { useEffect, useState } from "react";
import Footer from "../components/common/Footer";
import { useParams } from "react-router-dom";
import { apiConnector } from "../services/apiConnector";
import { getAbroadData } from "../services/apis";
import { useSelector } from "react-redux";
import Error from "./Error";

const MBBS = () => {
  const { loading } = useSelector((state) => state.profile);
  const { id } = useParams();
  const [mbbsData, setMbbsData] = useState(null);

  const TableSection = ({ title, headers, rows }) => (
    <div className="px-4 py-12 mx-auto max-w-maxContent">
      <h2 className="text-2xl font-bold text-[#CD1412] mb-6 text-center">{title}</h2>
      <table className="w-full text-left border border-collapse border-richblack-300">
        <thead>
          <tr className="bg-[#f8f8f8] text-richblack-800">
            {headers.map((header, i) => (
              <th key={i} className="border px-4 py-2">
                {header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row, rowIndex) => (
            <tr key={rowIndex}>
              {row.map((cell, cellIndex) => (
                <td key={cellIndex} className="border px-4 py-2">
                  {cell}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );

  useEffect(() => {
    const getCountry = async () => {
      try {
        const res = await apiConnector("POST", getAbroadData.ABROAD_DATA_API, {id});
        if (res?.data?.success) {
          setMbbsData(res.data.data); 
        } else {
          console.error("MBBS data not found");
        }
      } catch (error) {
        console.error("Error fetching MBBS data:", error);
      }
    };
    getCountry();
  }, [id]);

  if (!loading && !mbbsData) {
    return <Error />;
  }

  if (loading || !mbbsData) {
    return (
      <div className="grid min-h-[calc(100vh-3.5rem)] place-items-center">
        <div className="spinner"></div>
      </div>
    );
  }
  

  return (
    <>
      {/* <TableSection
        title="Comparison of Courses"
        headers={["Course Name", "Duration", "Level", "Fees"]}
        rows={[
          ["Computer Science", "4 Years", "Beginner", "$1200/year"],
          ["Mechanical Engineering", "4 Years", "Intermediate", "$1100/year"],
          ["Civil Engineering", "4 Years", "Advanced", "$1000/year"],
        ]}
      /> */}

      {mbbsData && (
        <div className="max-w-maxContentTab mx-auto px-4 py-12">
          {/* About MBBS */}
          <h2 className="text-4xl font-semibold mb-4 text-[#CD1412] text-center">About</h2>
          <p className="text-richblack-600">{mbbsData.about}</p>

          {/* Universities Table */}
          {/* <TableSection
            title="Top Universities"
            headers={["Name", "Location", "Ranking", "Fees"]}
            rows={mbbsData.universities.map((u) => [
              u.name,
              u.location,
              u.ranking,
              u.fees,
            ])}
          /> */}

          {/* Why Country */}
          <h2 className="text-2xl font-semibold mt-10 mb-2 text-[#CD1412] text-center">
            Why Study in this Country?
          </h2>
          <p>{mbbsData.whyCountry}</p>

          {/* Accommodation */}
          {/* <h2 className="text-2xl font-semibold mt-10 mb-2 text-[#CD1412]">
            Accommodation
          </h2>
          <p>{mbbsData.accomodation}</p> */}

          {/* Eligibility */}
          <TableSection
            title="Eligibility Criteria"
            headers={["Criteria", "Value"]}
            rows={mbbsData.eligibility.map((e) => [e.criteria, e.value])}
          />

          {/* Admission Process */}
          <h2 className="text-2xl font-semibold mt-10 mb-2 text-[#CD1412]">
            Admission Process
          </h2>
          <ol className="list-decimal list-inside">
            {mbbsData.admissionProcess.map((step, idx) => (
              <li key={idx} className="mb-1">
                <strong>{step.step}</strong>: {step.description}
              </li>
            ))}
          </ol>

          {/* Documents Required */}
          <TableSection
            title="Documents Required"
            headers={["Required"]}
            rows={mbbsData.docs.map((doc) => [
              doc.necessary,
              
            ])}
          />

          {/* Scholarship */}
          {/* <h2 className="text-2xl font-semibold mt-10 mb-2 text-[#CD1412]">
            Scholarship
          </h2>
          <p>{mbbsData.scholarship}</p> */}

          {/* Quick Facts */}
          {/* <TableSection
            title="Quick Facts"
            headers={["Label", "Value"]}
            rows={mbbsData.quickFacts.map((fact) => [fact.label, fact.value])}
          /> */}
        </div>
      )}

      <Footer />
    </>
  );
};

export default MBBS;
